import { createAction, props } from '@ngrx/store';
import { ISystemDetails } from '../models/common.models';
import { IShsEquipmentDataAttributes } from '../models/installedbase.models';

const sparePartAPIName = '[SparePart API]';

export const addItem = createAction(
  `${sparePartAPIName} Add new item`,
  props<{item: any}>(),
);

export const addAllItems = createAction(
  `${sparePartAPIName} Add all items`,
  props<{items: any[]}>(),
);

export const updateReorderWithSystemDetails = createAction(
  `${sparePartAPIName} Update reorder with system details`,
  props<{updatedSystemDetails: ISystemDetails}>(),
);

export const updateReorderWithSystemDetailsForFunctionalLocation = createAction(
  `${sparePartAPIName} Update reorder with system details`,
  props<{updatedSystemDetails: IShsEquipmentDataAttributes}>(),
);

export const confirmReorder = createAction(
  `${sparePartAPIName} Confirm reorder`,
);

export const completeReorder = createAction(
  `${sparePartAPIName} Complete reorder`,
);

export const cancelReorder = createAction(
  `${sparePartAPIName} Cancel reorder`,
);
